function initFreeResources(sectionId) {
  var grid = document.getElementById('resource-grid-' + sectionId);
  if (!grid) return;

  var cards = Array.from(grid.querySelectorAll('.resource-card'));
  var categoryContainer = document.getElementById('filter-category-' + sectionId);
  var gradeSelect = document.getElementById('filter-grade-' + sectionId);
  var resetBtn = document.getElementById('filter-reset-' + sectionId);
  var countEl = document.getElementById('filter-count-' + sectionId);
  var emptyEl = document.getElementById('resource-empty-' + sectionId);

  var activeCategory = 'all';
  var activeGrade = 'all';

  function uniqueSorted(values) {
    return Array.from(new Set(values.filter(Boolean))).sort();
  }

  function toLabel(value) {
    return value.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  var categories = uniqueSorted(cards.map(function (c) { return c.dataset.category; }));
  var grades = uniqueSorted(cards.map(function (c) { return c.dataset.grade; }));

  if (categoryContainer && categories.length) {
    categoryContainer.appendChild(buildCategoryBtn('All', 'all', true));
    categories.forEach(function (cat) {
      categoryContainer.appendChild(buildCategoryBtn(toLabel(cat), cat, false));
    });
  }

  if (gradeSelect && grades.length) {
    grades.forEach(function (grade) {
      var opt = document.createElement('option');
      opt.value = grade;
      opt.textContent = toLabel(grade);
      gradeSelect.appendChild(opt);
    });
  }

  function buildCategoryBtn(label, value, isActive) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'filter-btn' + (isActive ? ' is-active' : '');
    btn.dataset.value = value;
    btn.textContent = label;
    btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    btn.addEventListener('click', function () {
      activeCategory = value;
      var allBtns = categoryContainer.querySelectorAll('.filter-btn');
      allBtns.forEach(function (b) {
        var active = b.dataset.value === value;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      applyFilters();
    });
    return btn;
  }

  if (gradeSelect) {
    gradeSelect.addEventListener('change', function () {
      activeGrade = gradeSelect.value;
      applyFilters();
    });
  }

  if (resetBtn) {
    resetBtn.addEventListener('click', reset);
  }

  if (emptyEl) {
    var emptyReset = emptyEl.querySelector('.resource-empty-reset');
    if (emptyReset) emptyReset.addEventListener('click', reset);
  }

  function reset() {
    activeCategory = 'all';
    activeGrade = 'all';
    if (gradeSelect) gradeSelect.value = 'all';
    if (categoryContainer) {
      categoryContainer.querySelectorAll('.filter-btn').forEach(function (b) {
        var active = b.dataset.value === 'all';
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
    applyFilters();
  }

  function applyFilters() {
    var visible = 0;
    cards.forEach(function (card) {
      var matchCat = activeCategory === 'all' || card.dataset.category === activeCategory;
      var matchGrade = activeGrade === 'all' || card.dataset.grade === activeGrade;
      var show = matchCat && matchGrade;
      card.hidden = !show;
      if (show) visible++;
    });

    if (countEl) {
      countEl.textContent = visible < cards.length ? visible + ' of ' + cards.length + ' resources' : '';
    }
    if (emptyEl) emptyEl.hidden = visible > 0;
    if (resetBtn) resetBtn.hidden = activeCategory === 'all' && activeGrade === 'all';
  }
}
